export default __webpack_public_path__ + "429cb98fd9fd079f9560a02b6782e380.svg";